var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPieChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.916 2.43A1 1 0 018.4 3.747 9 9 0 1020.289 15.5a1 1 0 111.842.778A11 11 0 117.6 1.913a1 1 0 011.316.517z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.293 1.293A1 1 0 0112 1a11 11 0 0111 11 1 1 0 01-1 1H12a1 1 0 01-1-1V2a1 1 0 01.293-.707zM13 3.056V11h7.944A9 9 0 0013 3.056z",
    fill: "#000"
  })));
}
export default SvgPieChart;